import { getDomainName } from "./auth";
import { BUNDLE_PLAN_TYPE, BUNDLE_STATUS } from "./const";

// helper function to check if the bundle is active
export const isBundleActive = status => status === BUNDLE_STATUS.ACTIVE;

/**
 * helper function to check if the bundle is a paid bundle.
 * Reads the backend's `bundlePlanType`, which already accounts for paid addons —
 * e.g. a free mail plan made paid by a storage addon reports "paid".
 * @param {Object} currentPlanDetails - the current plan details
 * @returns {boolean} true if the bundle is on a paid plan
 */
export const isPaidBundle = currentPlanDetails =>
  currentPlanDetails?.bundlePlanType === BUNDLE_PLAN_TYPE.PAID;

/**
 * helper function to get the current bundle details from the bundle list
 * @param bundleList
 * @param currentPlan
 * @returns bundleDetails
 */
export const getCurrentBundleDetails = (bundleList, currentPlan) => {
  if (!bundleList?.length) return null;

  const domainName = getDomainName();
  const bundleId = currentPlan.bundleId;

  if (!bundleId) return null;

  const bundleDetails = bundleList.find(ele => ele.id === bundleId);

  if (!bundleDetails) {
    return deriveBundleDetailsFromCurrentPlan(currentPlan);
  }

  return {
    ...bundleDetails,
    name: domainName,
    status: bundleDetails.status,
    createdAt: bundleDetails.createdAt,
    bundleId: bundleDetails.id,
    locale: bundleDetails.locale,
    expiryDate: bundleDetails.expiryDate,
  };
};

/**
 * it is possible that the bundle list might not have current bundle (due to 100max limit set by backend)
 * in that case, we need to derive the bundle details from current plan
 * @param currentPlan
 * @returns bundleDetails
 */
export const deriveBundleDetailsFromCurrentPlan = currentPlan => {
  const domainName = getDomainName();

  if (!currentPlan?.bundleId) return null;

  console.info(
    "`deriveBundleDetailsFromCurrentPlan` bundle not found in bundle list, deriving from current plan"
  );
  return {
    name: domainName,
    status: currentPlan.status,
    createdAt: currentPlan.createdOn,
    bundleId: currentPlan.bundleId,
    locale: currentPlan.locale,
    expiryDate: currentPlan.expiryDate,
    orders: Object.entries(currentPlan.orderDetails).map(([key, value]) => ({
      id: value.id,
      type: key,
      planID: value.planId,
      planType: value.planType,
      status: value.status,
      createdAt: value.createdAt,
    })),
  };
};
